/* eslint-disable no-console */
import { Component, Inject } from '@angular/core';
import { ShellComponent } from '@core/components/shell/shell.component';
import { environment } from '@env/environment';
import { Store } from '@ngrx/store';
import { authActions } from '@store/actions/auth.actions';
import { appSelectors } from '@store/selectors/app.selectors';
import { filter, fromEvent, map } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { appActions } from '@store/actions/app.actions';
import { EventTypes, PublicEventsService } from 'angular-auth-oidc-client';
import { filterNil } from 'ngxtension/filter-nil';
import { BROADCAST_CHANNEL } from '@core/core.module';

@Component({
  selector: 'ac-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: true,
  imports: [ShellComponent],
  host: {
    '[class.no-scroll]': '_blockedScrollSig()',
  },
})
export class AppComponent {
  protected readonly _blockedScrollSig = this._store.selectSignal(appSelectors.blockedScroll);
  constructor(
    private _store: Store<Store>,
    private _oidcEvents: PublicEventsService,
    @Inject(BROADCAST_CHANNEL)
    private _broadcastChannel: BroadcastChannel
  ) {
    this._broadcastChannel.onmessage = () => this._store.dispatch(authActions.attemptLogout({ isMessage: true }));
    this._oidcEvents
      .registerForEvents()
      .pipe(
        filter((value) =>
          [EventTypes.CheckingAuth, EventTypes.CheckingAuthFinished, EventTypes.CheckingAuthFinishedWithError].includes(value.type)
        ),
        map((value) => value.type === EventTypes.CheckingAuth),
        takeUntilDestroyed()
      )
      .subscribe((checkingAuth) => this._store.dispatch(authActions.ongoingAuthCheck({ checking: checkingAuth })));
    if (environment.env !== 'local') {
      fromEvent(window, 'CookiebotOnLoad')
        .pipe(
          map(() => window.Cookiebot),
          filterNil(),
          takeUntilDestroyed()
        )
        .subscribe((value) => {
          if ('changed' in value && value['changed']) {
            location.reload();
          }
          if ('consent' in value) {
            this._store.dispatch(appActions.setCookiesConsent(value.consent));
          }
        });
    } else {
      this._store.dispatch(authActions.startAuth());
    }
  }
}
